import {useEffect } from 'react';
import {  BrowserRouter as Router, useLocation } from 'react-router-dom';
import { CommonProvider } from './contexts/common';
import { ThemeProvider, theme } from '@primer/react';
import { useAppDispatch } from './hooks/useAppDispatch';
import { useAppSelector } from './hooks/useAppSelector';
import { rootActions } from './state/actions/rootActions';
import BaseStyles from './BaseStyles';
import deepmerge from 'deepmerge';
import AuthorizedContent from './content/AuthorizedContent';
import UnAuthorizedContent from './content/UnAuthorizedContent';
import { appConst } from './AppConst';
import { useWebIcon } from './hooks/useWebIcon';
import LoaderPage from './components-ui/loader-page';
import { eAuthStatus } from './state/reducer-model/auth/IAuthReducer';
import { eReducerStatusBase } from './state/reducer-model/eReducerStatusBase';
import { HubProvider } from './contexts/HubProvider';
import UnAuthorizedContentVNPT from './content/UnAuthorizedContentVNPT';
import { PrintDialogProvider } from './contexts/PrintDialogContext';
import { ExportDialogProvider } from './contexts/ExportDialogContext';


const hasLoadingStatus = (value: unknown, visited = new WeakSet<object>()): boolean => {
  if (!value || typeof value !== "object") {
    return false;
  }

  if (visited.has(value as object)) {
    return false;
  }
  visited.add(value as object);

  const current = value as Record<string, unknown>;
  if (current.status === eReducerStatusBase.is_loading) {
    return true;
  }

  return Object.values(current).some((item) => hasLoadingStatus(item, visited));
};

const customTheme = deepmerge({
  ...theme,
  fontSizes: ['11px', '13px', '16px', '20px', '24px', '32px', '40px', '48px', '56px'],
}, {

  colorSchemes: {
    light: {
      colors: {
        accent: {
          fg: "var(--primary)",
          emphasis: "var(--primary)"
        },
        // --bgColor-accent-emphasis
        btn: {
          primary: {
            bg: "#DE3F0F",
            focusBg: "#DE3F0F",
            hoverBg: "#DE3F0F",
            selectedBg: "#DE3F0F",
            disabledBg: "rgba(222, 63, 15,0.6)"
          }
        }
      }
    }
  }
})

function App() {
  const dispath = useAppDispatch();
  const appState = useAppSelector((x) => x);
  const { user, status } = useAppSelector(x => x.auth);
   useEffect(() => {
    dispath(rootActions.auth.GET_USER_INFO_START(undefined));
  },[dispath]);
  const { themeMode } = useAppSelector(x => x.common.layout);
  const isGlobalLoading = hasLoadingStatus(appState);

  useEffect(() => {
    document.body.style.cursor = isGlobalLoading ? "wait" : "default";

    return () => {
      document.body.style.cursor = "default";
    };
  }, [isGlobalLoading]);

    useWebIcon(appConst.appURLLogo)
    
    if (status !== eReducerStatusBase.is_completed && status !== eAuthStatus.is_login_success && status !== eAuthStatus.is_logout) {
  // Đang gọi GET_USER_INFO_START, chờ kết quả
      return <LoaderPage />;
    }

  return (
   <Router>
      <CommonProvider>
      <ThemeProvider theme={customTheme} colorMode={themeMode}>
        <BaseStyles>
           {/* <AuthorizedContent /> */}
            {user && <>
              <HubProvider>
                <PrintDialogProvider> {/*Cái này để view report từ file html*/}
                 <ExportDialogProvider>  {/*Cái này để view report từ devexpress export ra*/}
                      <AuthorizedContent />
                 </ExportDialogProvider>
                </PrintDialogProvider>
              </HubProvider>
            </>}
            {!user &&
              (appConst.OIDC_UNIT === "vnpt" ? (
                <UnAuthorizedContentVNPT />
              ) : (
                <UnAuthorizedContent />
              ))}
        </BaseStyles>
      </ThemeProvider>
        </CommonProvider>     
   </Router>
  );
}

export default App;
